<template>
  <div class="agent-card" @click="$emit('chat', agent.id)">
    <!-- Avatar + badge de categoría -->
    <div class="card-header">
      <div :class="['agent-avatar', agent.category]">
        <i :class="['pi', categoryIcon]" />
      </div>
      <Tag :value="categoryLabel" :severity="categorySeverity" size="small" />
    </div>

    <!-- Nombre y descripción -->
    <div class="card-body">
      <h3 class="agent-name">{{ agent.name }}</h3>
      <p class="agent-desc">{{ agent.description || 'Asistente de IA listo para ayudarte.' }}</p>
    </div>

    <!-- Footer -->
    <div class="card-footer">
      <Button
        label="Iniciar chat"
        icon="pi pi-comments"
        class="chat-btn"
        @click.stop="$emit('chat', agent.id)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Button from 'primevue/button';
import Tag from 'primevue/tag';

const props = defineProps({
  agent: { type: Object, required: true },
});
defineEmits(['chat']);

const categoryIcon = computed(() => ({
  financiero: 'pi-chart-line', soporte: 'pi-headphones',
  ventas: 'pi-shopping-cart', legal: 'pi-book',
  rrhh: 'pi-users', logistica: 'pi-truck',
  salud: 'pi-heart', educacion: 'pi-graduation-cap',
  general: 'pi-android',
}[props.agent.category] || 'pi-android'));

const categoryLabel = computed(() => ({
  financiero: 'Financiero', soporte: 'Soporte', ventas: 'Ventas',
  legal: 'Legal', rrhh: 'RRHH', logistica: 'Logística',
  salud: 'Salud', educacion: 'Educación', general: 'General',
}[props.agent.category] || props.agent.category || 'General'));

const categorySeverity = computed(() => ({
  financiero: 'info', soporte: 'success', ventas: 'warning',
  legal: 'secondary', rrhh: 'contrast',
}[props.agent.category] || 'secondary'));
</script>

<style scoped>
.agent-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
}
.agent-card:hover {
  border-color: #6366f1;
  box-shadow: 0 4px 20px rgba(99, 102, 241, 0.12);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.agent-avatar {
  width: 48px; height: 48px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.4rem;
}
.agent-avatar.financiero { background: #dbeafe; color: #1d4ed8; }
.agent-avatar.soporte    { background: #dcfce7; color: #15803d; }
.agent-avatar.ventas     { background: #fef3c7; color: #b45309; }
.agent-avatar.legal      { background: #ede9fe; color: #6d28d9; }
.agent-avatar.rrhh       { background: #fce7f3; color: #be185d; }
.agent-avatar.logistica  { background: #ffedd5; color: #c2410c; }
.agent-avatar.salud      { background: #fee2e2; color: #b91c1c; }
.agent-avatar.educacion  { background: #e0f2fe; color: #0369a1; }
.agent-avatar.general    { background: #f3e8ff; color: #7c3aed; }

.card-body { flex: 1; }
.agent-name {
  margin: 0 0 0.4rem;
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
}
.agent-desc {
  margin: 0;
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-footer { margin-top: auto; }
.chat-btn { width: 100%; }
</style>
